import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "Insurance Services",
  },
];

const bannerData = {
  img:"assets/images/insurance-industry-banner.webp",
  leftHead:"Insurance Services",
  rightHead:"Bringing Structure and Control to Insurance Operations",
  desc:"In the insurance sector, accuracy, confidentiality, quick access to information are critical. Dox and Box enables insurers to manage policy and claims documents with precision, ensuring secure storage, streamlined workflows, instant retrieval to support faster decision-making and improved customer service."
}

const sectorData ={
  head:"Sector Overview",
  overview:"Insurance organizations operate in a highly regulated environment where managing large volumes of policies, claims, underwriting documents, customer records is a daily challenge. Dox and Box delivers secure, scalable, compliance-ready document management solutions that help insurers maintain accuracy, enhance data governance, improve overall operational efficiency."
}

const designData = {
  head:"Tailored Solutions for Insurance Services",
  img:"/assets/images/insurance-industry-design.webp",
  desc:[
    "We specialize in delivering structured and secure document management systems designed to meet the complex needs of insurance providers. Our solutions ensure that every document is organized, accessible, aligned with regulatory requirements.",
    "With a deep understanding of insurance workflows, we help organizations reduce manual effort, improve turnaround times, gain better control over critical information."
  ],
  list:[
    "Centralized management of policies, claims, customer records",
    "Role-based permissions to strengthen data protection",
    "Quick and reliable document retrieval",
    "Compliance-focused records management solutions",
    "Workflow automation for efficient claims handling",
    "Scalable systems designed to support organizational growth",
  ]
}

const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]

const investData = {
  head:"Why Insurance Providers Need Smart Document Management?",
  boxes:[
    {
      img:'/assets/images/insurance-industry-invest-1.webp',
      icon:"/assets/images/insurance-industry-invest-icon-1.webp",
      title:"Faster Policy Processing",
      desc:"Streamlines document workflows to issue policies and approvals quickly.",
    },
    {
      img:'/assets/images/insurance-industry-invest-2.webp',
      icon:"/assets/images/insurance-industry-invest-icon-2.webp",
      title:"Compliance Assurance",
      desc:"Ensures secure storage and easy retrieval to meet strict insurance regulations.",
    },
    {
      img:'/assets/images/insurance-industry-invest-3.webp',
      icon:"/assets/images/insurance-industry-invest-icon-3.webp",
      title:"Improved Claims Management",
      desc:"Centralized access accelerates claim verification and settlement.",
    },
    {
      img:'/assets/images/insurance-industry-invest-4.webp',
      icon:"/assets/images/insurance-industry-invest-icon-4.webp",
      title:"Enhanced Data Security",
      desc:"Protects sensitive customer and policy data with advanced access controls.",
    },
    {
      img:'/assets/images/insurance-industry-invest-5.webp',
      icon:"/assets/images/insurance-industry-invest-icon-5.webp",
      title:"Reduced Operational Costs",
      desc:"Minimizes manual handling, paperwork, storage expenses.",
    },
    {
      img:'/assets/images/insurance-industry-invest-6.webp',
      icon:"/assets/images/insurance-industry-invest-icon-6.webp",
      title:"Better Customer Experience",
      desc:"Enables quick responses and seamless service through instant document access.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/insurance-industry-serve-1.webp",
      title:"Media & Entertainment",
      desc:"Media & Entertainment requires management of digital content and documents, ensuring organized, secure, accessible assets.",
      btnText:"Know More",
      slug:"/media-entertainment-records-management"
    },
    {
      img:"/assets/images/insurance-industry-serve-2.webp",
      title:"Healthcare Services",
      desc:"Healthcare requires secure and efficient management of patient records and critical data, ensuring organized and compliant document systems.",
      btnText:"Know More",
      slug:"/healthcare"
    },
  ]
}

export default function InsuranceServices() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
